export const keyToSaveAndRetriveSKUSetting = 'timeline';
